export const keyToSaveAndRetriveSKUSetting = 'timeline';
